import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import lang from '@blade/common/pages/alert-details/lang/index';
import TableCard from '@blade-sxp/alarm-center/pages/components/alarm-list/table-card.vue';
import { AlarmCenterModule } from '@blade-sxp/alarm-center/store/index';
import { AlarmDetailsModule } from '@blade/common/store/alarm-details';
let default_1 = class default_1 extends Vue {
    taskList;
    currenTime = Date.now().toString();
    newLists = [];
    get alarListTotal() {
        return AlarmDetailsModule.alarListTotal;
    }
    get parentClassLength() {
        return this.taskList && this.taskList.length;
    }
    onChangeTaskList() {
        this.newLists = [];
        const len = this.taskList?.[0] ? Object.keys(this.taskList[0]).length : 0;
        if (len > 1) {
            const obj = this.taskList?.[0];
            const sortedObj = this.sortObject(obj);
            for (const key in sortedObj) {
                const newObj = {};
                newObj[key] = obj[key];
                this.newLists.push(newObj);
            }
            this.newLists = this.newLists.reverse();
        }
        else {
            this.newLists = this.taskList;
        }
        if (this.taskList.length > 0) {
            AlarmCenterModule.updateAlarList(this.newLists);
        }
    }
    sortObject(obj) {
        const keys = Object.keys(obj).sort();
        const sortedObj = {};
        for (let i = 0; i < keys.length; i++) {
            sortedObj[keys[i]] = obj[keys[i]];
        }
        return sortedObj;
    }
    timeDateFormat(time) {
        return moment(Number(time)).format('MM-DD');
    }
    getObjectFirstKey(item) {
        if (item) {
            return item && Object.keys(item)[0];
        }
    }
    isItToday(item) {
        if (item) {
            const today = this.timeDateFormat(this.currenTime);
            const beforeOne = this.timeDateFormat(this.getObjectFirstKey(item));
            return beforeOne === today ? this.$t('today') : beforeOne;
        }
    }
    updateList() {
        this.$emit('update-list');
    }
    showDetailDialog() {
        this.$emit('show-detail-dialog');
    }
    initTimeData(data) {
        this.currenTime = Date.now().toString();
        let timeaArr = [];
        const b = data.reduce((prev, cur) => {
            if (!prev[this.timeDateFormat(cur.alertTime)]) {
                prev[this.timeDateFormat(cur.alertTime)] = [];
            }
            prev[this.timeDateFormat(cur.alertTime)].push(cur);
            return prev;
        }, {});
        for (let i in b) {
            const dayNum = this.countAlertNumber(b[i]);
            timeaArr.push({
                count: dayNum,
                timeTitle: i,
                lists: b[i],
            });
        }
        // this.lists = timeaArr;
        AlarmCenterModule.updateAlarList(timeaArr);
    }
    countAlertNumber(list) {
        return list.reduce((pre, cur) => {
            const curNumber = cur?.foldsTotal ?? 0;
            pre = curNumber + pre;
            return pre;
        }, 0);
    }
};
__decorate([
    Prop({ type: Array, default: [] })
], default_1.prototype, "taskList", void 0);
__decorate([
    Watch('taskList')
], default_1.prototype, "onChangeTaskList", null);
default_1 = __decorate([
    Component({
        name: 'TableList',
        components: {
            TableCard,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
